import { render, staticRenderFns } from "./PointType.vue?vue&type=template&id=1017bc35&scoped=true&"
import script from "./PointType.vue?vue&type=script&lang=ts&"
export * from "./PointType.vue?vue&type=script&lang=ts&"
import style0 from "./PointType.vue?vue&type=style&index=0&id=1017bc35&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1017bc35",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
